import { Link } from 'react-router-dom';

import ImgSlot from '@/ui/ImgSlot';
import type { Resident } from '@/types';

import styles from './ArtCardStrip.module.css';

interface ArtCardStripProps {
  artist: Resident;
  index: number;
}

export default function ArtCardStrip({ artist, index }: ArtCardStripProps) {
  const num = '/' + String(index + 1).padStart(3, '0');
  const href = `/artists/${artist.slug}`;

  return (
    <Link to={href} className={styles.cell} aria-label={artist.name}>
      <div className={styles.img}>
        <ImgSlot
          src={artist.portraitUrl}
          alt={artist.name}
          label={`${artist.name} · PORTRAIT`}
          mono
        />
        <span className={styles.stamp}>{num}</span>
        <span className={styles.stampR}>
          {artist.role === 'GUEST RESIDENT' ? 'GUEST' : 'RES'}
        </span>
        <span className={styles.since}>SINCE {artist.since}</span>
      </div>
      <div className={styles.info}>
        <span className={styles.name}>{artist.name}</span>
        <div className={styles.row}>
          <span>{artist.tag}</span>
          <span>{artist.hometown}</span>
        </div>
        <div className={styles.marq}>
          <div className={styles.marqTrack}>
            {[...artist.genres, ...artist.genres, ...artist.genres].map((g, k) => (
              <span key={`${g}-${k}`}>{g} ◦</span>
            ))}
          </div>
        </div>
        <div className={styles.row}>
          <span>{artist.bpm}</span>
          <span className={styles.arrow}>READ</span>
        </div>
      </div>
    </Link>
  );
}
